import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteData, getData, postData, putData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";

export const createStamp = createAsyncThunk(
    "admin/createStamp",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await postData(`/stamps/create-stamp`, data);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const fetchStamps = createAsyncThunk(
    "admin/fetchStamps",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await getData(`/stamps/get-stamps`);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const updateStamp = createAsyncThunk(
    "admin/updateStamp",
    async ({ id, data }, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await putData(`/stamps/update-stamp?id=${id}`, data);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteStamp = createAsyncThunk(
    "admin/deleteStamp",
    async (id, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await deleteData(`/stamps/delete-stamp?id=${id}`);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);



